import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {CustomScrollbarModule} from '../../components/custom-scrollbar';
import {L10nModule} from '../../components/translate';
import {WidgetHeaderHidingModule} from '../../directives/witget-header-hiding';
import {WidgetBodyRendererModule} from '../dashboard/layout/widget/widget-body-renderer';
import {WidgetModule} from '../dashboard/layout/widget/widget.module';
import {DetachedWidgetPageDefResolverService} from './detached-widget-page-def-resolver.service';
import {PageWidgetConfigurableDirective} from './page-widget-configurable.directive';
import {PageWidgetRemovableDirective} from './page-widget-removable.directive';
import {WatchlistsResolverService} from './watchlists-resolver.service';
import {WidgetPageEnvModule} from './widget-page-env.module';
import {WidgetPageRoutingModule} from './widget-page-routing.module';
import {WidgetPageComponent} from './widget-page.component';

@NgModule({
    imports: [
        WidgetPageRoutingModule,
        L10nModule,
        CommonModule,
        CustomScrollbarModule,
        WidgetBodyRendererModule,
        WidgetModule,
        WidgetHeaderHidingModule,
        WidgetPageEnvModule
    ],
    declarations: [
        WidgetPageComponent,
        PageWidgetRemovableDirective,
        PageWidgetConfigurableDirective
    ],
    providers: [
        WatchlistsResolverService,
        DetachedWidgetPageDefResolverService
    ]
})
export class WidgetPageModule {}
